<template>
    <v-row v-if="prepared">
        <v-col cols="11">
            <p>Click to select/deselect group: </p>
            <v-chip v-for="(item,index) in groups" 
                    :key="index" style="margin:2px"
                    :color="getChipColor(item)" 
                    @click="changeGroupStatus(item)">
                {{item.group_name}}
            </v-chip>
        </v-col>
    </v-row>
</template>

<script>
 import axios from '../../axios-auth'


export default {
    data() {
        return {
            groups_ids :null,
            groups:null,
            prepared: false,
        }
    },
    props: ['course_id'],
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            let _data = {course_id: this.course_id}

            axios.post('/get-teaching-groups-in-course', _data, this.$store.getters.getAxiosConfig )
                .then(res => {            
                    this.groups_ids = []
                    this.groups = []
                    var _lg = []
                    const _localg = localStorage.getItem('student_groups')
                    if (_localg) _lg = JSON.parse(_localg)
                    
                    var _sett = 0
                    for(let i=0; i<res.data.groups.length; i++) {
                        _sett = 0
                        if (_localg) {
                            for(let j=0; j<_lg.length; j++) {
                                if (res.data.groups[i].id == _lg[j]) _sett = 1
                            }
                        }
                        if (_sett) this.groups_ids.push(res.data.groups[i].id)
                        this.groups.push( {id : res.data.groups[i].id, group_name: res.data.groups[i].group_name, show: _sett})
                    }
                    this.refreshData()
                    this.prepared = true
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        getChipColor(item) {
            if (item.show == 1) return "orange"
            return "silver"
        },
        changeGroupStatus(item) {
            if (item.show == 1)
                this.groups_ids.splice(this.groups_ids.indexOf(item.id),1)
            else
                this.groups_ids.push(item.id)
            item.show = Math.abs(1-item.show)
            this.refreshData()
        },
        refreshData() {
            const _dataString = JSON.stringify(this.groups_ids)
            localStorage.setItem('student_groups', _dataString)
            //+ info do store
            this.$store.commit('setStudentGroupsChanged', true)
        }
      }
}
</script>
